import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { darken } from "polished";
import { Colors, rawColorValues } from "../../index";
import { colorTest } from "../../utils";
export const OutOfStockColorSwatch = ({ color, size = 20 }) => {
    const borderColor = color && color.length > 0
        ? colorTest(color, rawColorValues[Colors.white][0]) > 1
            ? "none"
            : darken(0.2, color)
        : "none";
    return (_jsxs("svg", { width: `${size}`, height: `${size}`, fill: "none", "aria-hidden": "true", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "10", cy: "10", r: "6", fill: color, stroke: borderColor }), _jsx("circle", { cx: "10", cy: "10", r: "3", fill: "#fff" }), _jsx("g", { transform: "translate(7.4 6) rotate(45 1 5)", children: _jsx("rect", { width: "3", height: "8", fill: color }) })] }));
};
//# sourceMappingURL=OutOfStockColorSwatch.js.map